import { render, staticRenderFns } from "./xtxx_xt.vue?vue&type=template&id=04f0b1de&scoped=true&"
import script from "./xtxx_xt.vue?vue&type=script&lang=js&"
export * from "./xtxx_xt.vue?vue&type=script&lang=js&"
import style0 from "./xtxx_xt.vue?vue&type=style&index=0&id=04f0b1de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f0b1de",
  null
  
)

export default component.exports